import {HookMatchCriteria, Ng2StateDeclaration, StatesModule, UIRouter} from '@uirouter/angular';
import * as Pages from '../app/pages';
import {Injector} from '@angular/core';
import {StorageService} from '../app/services';
import {STATE_NAMES} from '../app/common';
import {ROUTE_NAMES} from './common/routing-names';

export const STATES: Ng2StateDeclaration[] = [
  {
    name: STATE_NAMES.login,
    url: '/login',
    component: Pages.LoginPageComponent
  },
  {
    name: STATE_NAMES.forgotPassword,
    url: '/forgot-password',
    component: Pages.ForgotPasswordPageComponent
  },
  {
    name: STATE_NAMES.changePassword,
    url: '/change-password/:token',
    component: Pages.ChangePasswordPageComponent
  },
  {
    name: STATE_NAMES.userProfile,
    url: '/profile',
    component: Pages.UserProfileComponent,
    params: {
      name: ROUTE_NAMES.userProfile
    }
  },
  {
    name: STATE_NAMES.travels,
    url: '/travels',
    component: Pages.TravelsPageComponent,
    data: {
      requireAuth: true
    }
    // params: {
    //   name: ROUTE_NAMES.travels
    // }
  },
  {
    name: STATE_NAMES.travel,
    url: '/travel/:id',
    component: Pages.TravelProfileComponent,
    params: {
      travel: {},
      name: ROUTE_NAMES.travels,
    }
  },
  {
    name: STATE_NAMES.events,
    url: '/events',
    component: Pages.EventsPageComponent,
    data: {
      requireAuth: true
    },
    params: {
      event: {},
    }
  },
  {
    name: STATE_NAMES.main,
    url: '/main',
    component: Pages.MainPageComponent,
    data: {
      requireAuth: true
    }
  },
  {
    name: STATE_NAMES.chat,
    url: '/chat',
    component: Pages.ChatPageComponent,
    data: {
      requireAuth: true
    }
  },
  {
    name: STATE_NAMES.app,
    component: Pages.DefaultMasterPageComponent,
    abstract: true,
    data: {
      requireAuth: true
    }
  },
];

export function routerConfigFn(router: UIRouter, injector: Injector, module: StatesModule) {
  // Redirect to home page if don't match any rule
  router.urlService.rules.otherwise({state: STATE_NAMES.main});

  const routingService = router.stateService;
  const storage = injector.get(StorageService);

  // Redirect to login if not authenticated
  // Not needed anymore because we redirect to login page in response.interceptor
  const criteriaAuth: HookMatchCriteria = {to: (state) => state.data && state.data.requireAuth};
  // router.transitionService.onBefore(criteriaAuth, (transition) => {
  //   const value = storage.accessToken;
  //   return new Promise((resolve, reject) => {
  //     if (!value && transition.from().name !== 'login') {
  //       resolve(routingService.target(STATE_NAMES.login, null, {reload: true}));
  //     } else {
  //       resolve(true);
  //     }
  //   });
  // });

  // Redirect to dashboard if we are already authenticated
  const criteria = {to: `${STATE_NAMES.login}.*`};
  router.transitionService.onBefore(criteria, (transition) => {
    const value = storage.accessToken;
    return new Promise((resolve, reject) => {
      if (value) {
        resolve(routingService.target(STATE_NAMES.main));
      } else {
        resolve(true);
      }
    });
  });
}
